import { Formik, Field, Form } from "formik";
import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import LoaderButton from "../../../shared-components/button/loader-button";
import { checkAgreementPaswordSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import Label from "../../../shared-components/label/label";
import { integerRegex } from "../../../constants/constants";
import FormikFormInputForRegexCheck from "../../../shared-components/FormikFormHandlers/FormikFormInputForRegexCheck";
import { observer } from "mobx-react";
import { useStore } from "../../../contexts/store-provider";
import { getStoreIdFromLocalStorage } from "../../../helpers/localstorage-helper";
import { formatMessage } from "../../../translations/format-message";
import toast from "react-hot-toast";
import { toHalfWidth } from "../../../helpers/validate-helper";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
 
interface IProps {
  submitHandler: () => void;
  modalClosed: () => void;
}
 
const CheckAgreementCard = (props: IProps) => {
  const { smrStore } = useStore();
  const {
    verifyNavigationPasswordForAgreementState,
    resetVerifyNavigationPasswordForAgreementState,
    VerifyNavigationPasswordForAgreementService,
  } = smrStore;
 
  const verifyPasswordHandler = (password: string) => {
    let storeId = getStoreIdFromLocalStorage();
    if (storeId > 0)
      VerifyNavigationPasswordForAgreementService(storeId, password);
  };
 
  useEffect(() => {
    if (verifyNavigationPasswordForAgreementState.success) {
      toast.success(formatMessage("password_verified_success"));
      props.submitHandler();
      resetVerifyNavigationPasswordForAgreementState();
    }
  }, [verifyNavigationPasswordForAgreementState.success]);
 
  return (
    <Modal
      className="add-user-modal correction-modal fancy-modal"
      show={true}
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id="sign_agreement" />
 
          <button onClick={props.modalClosed} className="Crossicons">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        {
          verifyNavigationPasswordForAgreementState.inProgress &&
          <FormLoader loading={verifyNavigationPasswordForAgreementState.inProgress} />
        }
        <Formik
          initialValues={{ Password: "" }}
          enableReinitialize
          validationSchema={checkAgreementPaswordSchema}
          onSubmit={(values) => {
            verifyPasswordHandler(toHalfWidth(values?.Password ?? ""));
          }}
        >
          {({}) => (
            <Form>
              <div className="mb-4 p-3">
                <Label
                  className="label-style"
                  required={true}
                  label="password"
                />
                <Field
                  name="Password"
                  className="form-control"
                  type="text"
                  placeholder="password"
                  regex={integerRegex}
                  as={FormikFormInputForRegexCheck}
                />
              </div>
              <div className="modal-footer center-content">
                <Button
                  variant="outline-danger"
                  type="button"
                  onClick={props.modalClosed}
                  disabled={false}
                >
                  <i className="bi bi-x-lg me-1"></i>
                  <FormattedMessage id="close" />
                </Button>
                <LoaderButton
                  type="submit"
                  iconName="bi-check-lg"
                  isLoading={false}
                  text="button_save"
                />
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
 
export default observer(CheckAgreementCard);
